import Button from "components/Buttons/Button/Button";
import MainCard from "components/layout/MainCard/MainCard";
import Sitemap from "routes/sitemap";
import background from "../../assets/images/backgrounds/module_locked.png";
import scss from "./ModuleLocked.module.scss";
import { useTranslation } from "react-i18next";

const ModuleLocked = () => {
    const { t } = useTranslation();

    return (
        <MainCard>
            <div className="page-container">
                <div className={`p page-content ${scss.container}`} style={{ backgroundImage: `url(${background})` }}>
                    <h3 className="h-underline">{t("global-module_locked-title")}</h3>
                    <p>
                        {t("global-module_locked-p1")}
                        <br />
                        {t("global-module_locked-p2")}
                    </p>

                    <p>{t("global-module_locked-p3")}</p>
                    <Button to={Sitemap.contact._} label={"global-module_locked-button"} />
                </div>
            </div>
        </MainCard>
    );
};

export default ModuleLocked;
